var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          on: {
            click: function ($event) {
              return _vm.onCustToFollowUser()
            },
          },
        },
        [_vm._v("客户同步")]
      ),
      _vm._v(" "),
      _c("UserSelect", {
        key: _vm.timer,
        ref: "userSelect",
        attrs: { "show-user-select": _vm.showUserSelect },
        on: {
          close: _vm.onUserSelectClose,
          "select-user-callBack": _vm.selectUserCallBack,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }